import styled from "styled-components";

import ButtonDs from "ds/Button";

export const Button = styled(ButtonDs)`
  display: flex;
  margin: auto;

  &::after {
    display: none;
  }
`;
